function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 12C24 18.6277 18.6277 24 12 24C5.37308 24 0 18.6277 0 12C0 5.37303 5.37308 0 12 0C18.6277 0 24 5.37303 24 12Z",
  fill: "#8B8B8B"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.0001 11.9997C10.0001 7.89962 12.4683 4.376 16 2.8328C14.7747 2.29738 13.4219 2 11.9996 2C6.47719 2 2 6.47726 2 11.9997C2 17.5228 6.47724 22 11.9996 22C13.4219 22 14.7747 21.7019 16 21.1666C12.4683 19.6234 10.0001 16.1004 10.0001 11.9997Z",
  fill: "#FECD57"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.00062 11.9997C4.00062 6.81566 7.94686 2.55225 13 2.04983C12.6711 2.01688 12.3385 2 12.0015 2C6.47805 2 2 6.47726 2 11.9997C2 17.5228 6.4781 22 12.0015 22C12.3385 22 12.6711 21.9824 13 21.9502C7.94686 21.4471 4.00062 17.1844 4.00062 11.9997Z",
  fill: "#F5BA45"
});

var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon.297392bb.svg";
export { ForwardRef as ReactComponent };